import { FC } from 'react'

import { nanoid } from 'nanoid'

import { Paper } from 'shared/ui/paper'

import styles from './styles.module.scss'

interface Props {
  title?: string
  subtitle?: string
  list: {
    label?: string
    value?: string | null
  }[]
}

export const ListBlock: FC<Props> = (props) => {
  const { title, list, subtitle } = props

  return (
    <Paper padding={[16]}>
      <div className={styles.container}>
        <div className={styles.text}>
          <p className={styles.title}>{title}</p>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>

        <div className={styles.content}>
          {list?.map((item) => (
            <div
              className={styles.wrapper}
              key={nanoid()}
            >
              <span className={styles.label}>{item?.label || ''}</span>
              <p className={styles.value}>{item?.value || ''}</p>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  )
}
